import {Observable} from 'rxjs';
import {catchError, mergeMap, flatMap} from 'rxjs/operators';
import {List} from 'immutable';

import {combineEpics} from 'web-app/util/redux-observable';
import {fetchBillPayerObservable} from 'web-app/react/entities/bill-payers/epics';
import {fetchBillPayerPaymentsObservable} from 'web-app/react/entities/recurring-payments/epics';

import * as Actions from './actions';

const fetchBillPayer = action$ =>
    action$.ofType(Actions.fetch.type).pipe(
        mergeMap(({payload}) =>
            fetchBillPayerObservable(payload.institutionId, payload.billPayerId).pipe(
                flatMap(successAction => {
                    return List([successAction, Actions.fetchSuccess.action()]);
                }),
                catchError(e => Observable.of(Actions.fetchFailed.action(e))),
            ),
        ),
    );

const fetchRecurringPayments = action$ =>
    action$.ofType(Actions.fetchRecurringPayments.type).pipe(
        mergeMap(({payload}) =>
            fetchBillPayerPaymentsObservable(payload.institutionId, payload.billPayerId).pipe(
                flatMap(successAction => {
                    return [successAction, Actions.fetchRecurringPaymentsSuccess.action()];
                }),
                catchError(e => Observable.of(Actions.fetchRecurringPaymentsFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchBillPayer, fetchRecurringPayments);
